var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuLeftChevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7579 0.402103C9.59383 1.00251 7.47422 2.41012 6.3007 4.74402C4.19813 8.92562 5.20173 11.9341 4.50316 15.0064C3.80459 18.0788 3.3646 18.4724 1.77941 20.9496C-0.107527 23.8984 0.216176 28.0859 2.63761 30.3053C5.03278 32.4833 7.41997 33.8077 11.6148 33.0926C15.7681 32.4035 15.4761 29.4927 19.8342 28.5306C24.1922 27.5686 28.219 28.9941 30.5016 26.8762C32.8951 24.6553 36.1896 20.2722 33.0178 14.3103C31.1825 10.8605 26.2847 10.7026 24.1275 7.47799C21.9703 4.2534 21.4254 2.53171 19.7347 1.53951C17.2473 0.0798175 15.3435 -0.0885218 12.7579 0.402103Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5606 16.9991L18.8712 14.6885C18.959 14.6006 18.959 14.4582 18.8712 14.3703L18.1287 13.6278C18.0408 13.54 17.8984 13.54 17.8105 13.6278L15.0355 16.4028C14.9933 16.445 14.9696 16.5023 14.9696 16.5619V17.4362C14.9696 17.4959 14.9933 17.5531 15.0355 17.5953L17.8105 20.3703C17.8984 20.4582 18.0408 20.4582 18.1287 20.3703L18.8712 19.6278C18.959 19.54 18.959 19.3975 18.8712 19.3097L16.5606 16.9991Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLeftChevron);
export default __webpack_public_path__ + "static/media/menu-left-chevron.8f75b81b8354cfbcef7302849b4c3450.svg";
export { ForwardRef as ReactComponent };